import { useMemo } from 'react';
import { useLoadingDelay } from '@givebutter/react-util';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGlobalSearchResults } from 'components/search/useGlobalSearchResults';
import { useSearchStore } from 'components/search/useSearchStore';

const SearchEmptyResults = () => {
    const { query, isTypesensePending: isTypesensePendingRaw } = useSearchStore();
    const { data } = useGlobalSearchResults();
    const { isLoading: isTypesensePending } = useLoadingDelay(isTypesensePendingRaw);

    const noResultsText = useMemo(() => {
        if (isTypesensePending) {
            return 'Searching...';
        }

        return 'No results found';
    }, [isTypesensePending]);

    if (query.length === 0 || !data?.noSearchResults) {
        return null;
    }

    return (
        <div className={'flex flex-col items-center justify-center gap-4 p-8'}>
            <div
                className={
                    'flex aspect-square h-12 items-center justify-center rounded-md bg-gray-100'
                }
            >
                <FontAwesomeIcon className={'font-medium text-gray-600'} icon={faSearch} />
            </div>
            <p className={'font-medium text-gray-600'}>{noResultsText}</p>
        </div>
    );
};

export { SearchEmptyResults };
